import React, { Component } from 'react';
import { message, Upload, Radio, Popconfirm } from 'antd';
import { UploadOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { ButtonItem } from '../../../../Components/Items';
import axios from 'axios';
import { connect } from 'react-redux';
import SignaturePad from 'signature_pad';

class FirmaDigitalConfiguracion extends Component {
  canvasRef = React.createRef();
  sigPad = null;

  state = {
    firmaActual: null,
    firmaData: null,
    firmaMode: 'subir',
    loadingFirma: false,
  };

  componentDidMount() {
    this.consultarFirma();
  }

  componentWillUnmount() {
    if (this.sigPad) {
      this.sigPad.off();
      this.sigPad = null;
    }
  }

  async consultarFirma() {
    await axios
      .post('usuario/selectFirma', {}, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ firmaActual: res.data.firma || null });
        }
      })
      .catch(() => {});
    this.initSignaturePad();
  }

  initSignaturePad() {
    setTimeout(() => {
      if (this.canvasRef.current) {
        if (this.sigPad) {
          this.sigPad.off();
        }
        this.sigPad = new SignaturePad(this.canvasRef.current);
      }
    }, 150);
  }

  guardarFirma() {
    let firmaToSend;
    if (this.state.firmaMode === 'dibujar') {
      if (!this.sigPad || this.sigPad.isEmpty()) {
        message.warning('Por favor dibuja tu firma antes de guardar');
        return;
      }
      firmaToSend = this.sigPad.toDataURL('image/png');
    } else {
      if (!this.state.firmaData) {
        message.warning('Por favor selecciona una imagen');
        return;
      }
      firmaToSend = this.state.firmaData;
    }
    this.setState({ loadingFirma: true });
    axios
      .post(
        'usuario/guardarFirma',
        { firma: firmaToSend },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingFirma: false });
        if (res.data.success === 2) {
          message.success('Firma guardada correctamente');
          this.setState({ firmaActual: firmaToSend, firmaData: null });
          if (this.sigPad) this.sigPad.clear();
        } else {
          message.error('No se pudo guardar la firma');
        }
      })
      .catch(() => {
        this.setState({ loadingFirma: false });
        message.error('Error al guardar la firma');
      });
  }

  borrarFirma() {
    this.setState({ loadingFirma: true });
    axios
      .post(
        'usuario/borrarFirma',
        {},
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingFirma: false });
        if (res.data.success === 2) {
          message.success('Firma borrada');
          this.setState({ firmaActual: null, firmaData: null });
          if (this.sigPad) this.sigPad.clear();
        } else {
          message.error('No se pudo borrar la firma');
        }
      })
      .catch(() => {
        this.setState({ loadingFirma: false });
        message.error('Error al borrar la firma');
      });
  }

  render() {
    return (
      <div style={{ maxWidth: 600 }}>
        {/* Firma actual guardada */}
        {this.state.firmaActual && (
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Firma actual:</div>
            <img
              src={this.state.firmaActual}
              alt="Firma actual"
              style={{ maxHeight: 160, maxWidth: '100%', border: '1px solid #d9d9d9', borderRadius: 4, padding: 4, background: '#fff' }}
            />
            <div style={{ marginTop: 8 }}>
              <Popconfirm
                title="¿Seguro que quieres borrar la firma?"
                onConfirm={this.borrarFirma.bind(this)}
                okText="Sí"
                cancelText="No"
              >
                <ButtonItem type="default" size="small" rojo loading={this.state.loadingFirma}>
                  Borrar firma
                </ButtonItem>
              </Popconfirm>
            </div>
          </div>
        )}

        {/* Selector de modo */}
        <Radio.Group
          value={this.state.firmaMode}
          onChange={(e) => {
            this.setState({ firmaMode: e.target.value, firmaData: null }, () => {
              if (e.target.value === 'dibujar') this.initSignaturePad();
            });
          }}
          style={{ marginBottom: 16 }}
        >
          <Radio.Button value="subir">Subir imagen</Radio.Button>
          <Radio.Button value="dibujar">Dibujar</Radio.Button>
        </Radio.Group>

        {/* Modo subir */}
        {this.state.firmaMode === 'subir' && (
          <div style={{ marginBottom: 16 }}>
            <Upload
              accept="image/png,image/jpeg"
              showUploadList={false}
              beforeUpload={(file) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                  const img = new Image();
                  img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;
                    canvas.getContext('2d').drawImage(img, 0, 0);
                    this.setState({ firmaData: canvas.toDataURL('image/png') });
                  };
                  img.src = e.target.result;
                };
                reader.readAsDataURL(file);
                return false;
              }}
            >
              <ButtonItem icon={<UploadOutlined />}>Seleccionar imagen (PNG / JPG)</ButtonItem>
            </Upload>
            {this.state.firmaData && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Vista previa:</div>
                <img
                  src={this.state.firmaData}
                  alt="Vista previa firma"
                  style={{ maxHeight: 160, maxWidth: '100%', border: '1px solid #d9d9d9', borderRadius: 4, padding: 4, background: '#fff' }}
                />
              </div>
            )}
          </div>
        )}

        {/* Modo dibujar */}
        {this.state.firmaMode === 'dibujar' && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Dibuja tu firma:</div>
            <canvas
              ref={this.canvasRef}
              width={560}
              height={150}
              style={{
                border: '1px solid #d9d9d9',
                borderRadius: 4,
                touchAction: 'none',
                cursor: 'crosshair',
                display: 'block',
              }}
            />
            <ButtonItem
              size="small"
              style={{ marginTop: 8 }}
              onClick={() => { if (this.sigPad) this.sigPad.clear(); }}
            >
              Limpiar
            </ButtonItem>
          </div>
        )}

        {/* Botón guardar firma */}
        <ButtonItem
          type="primary"
          cyan
          loading={this.state.loadingFirma}
          onClick={this.guardarFirma.bind(this)}
          icon={<SafetyCertificateOutlined />}
        >
          Guardar firma
        </ButtonItem>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(FirmaDigitalConfiguracion);
